var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3573 5.64267C10.667 5.95221 10.9126 6.31971 11.0801 6.72418C11.2477 7.12866 11.334 7.56219 11.334 8C11.334 8.43781 11.2477 8.87134 11.0801 9.27581C10.9126 9.68029 10.667 10.0478 10.3573 10.3573M12.2427 3.75733C12.7998 4.31449 13.2418 4.97592 13.5433 5.70388C13.8449 6.43184 14.0001 7.21206 14.0001 8C14.0001 8.78794 13.8449 9.56816 13.5433 10.2961C13.2418 11.0241 12.7998 11.6855 12.2427 12.2427M3.724 10H2.66667C2.48986 10 2.32029 9.92976 2.19526 9.80474C2.07024 9.67971 2 9.51014 2 9.33333V6.66667C2 6.48986 2.07024 6.32029 2.19526 6.19526C2.32029 6.07024 2.48986 6 2.66667 6H3.724L6.862 2.862C7.282 2.442 8 2.73933 8 3.33333V12.6667C8 13.2607 7.282 13.558 6.862 13.138L3.724 10Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUpOutline);
export default __webpack_public_path__ + "static/media/VolumeUpOutline.d2837e60a3b2d65d660ddf952d779dda.svg";
export { ForwardRef as ReactComponent };